module.exports = __webpack_public_path__ + "public/images/Illustration_Graph_Graduation_200x200-Color.1a95d045fc462da7d3c4826b0da8ff4a.png";